class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector('.header-wrapper');
    if (this.header) this.header.preventHide = false;

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    normalizeUkoiCartDrawer();
    if (this.header) this.header.preventHide = true;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden-drawer');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden-drawer');
    if (this.header) this.header.preventHide = false;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    normalizeUkoiCartDrawer();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

const UKOI_PROMO_PRESENTATION = {
  exosomeHandle: 'exosome-collection',
  exosomeTitle: 'Exosome Cellular Renewal System',
  exosomeVariantId: '48325774770394',
  giftTitle: 'SPF 50 Mattifying & Anti-Dark Spot Cream',
  giftVariantId: '47643211595994',
  discountTitle: 'Complimentary SPF 50',
  prices: null,
  pricesPromise: null
};

function normalizeUkoiCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  updateUkoiCartShipping(drawer);
  updateUkoiCartProductSublines(drawer);
  removeUkoiSnailBuyXGetYDiscountRows(drawer);
  updateUkoiExosomePromoPresentation(drawer);
  updateUkoiSpfGiftPresentation(drawer);
  updateUkoiEmptyCartCta(drawer);
}

function normalizeUkoiMainCart() {
  const cart = document.querySelector('.main-cart');
  if (!cart) return;

  updateUkoiExosomePromoPresentation(cart);
  updateUkoiSpfGiftPresentation(cart);
}

function normalizeUkoiCartPresentation() {
  normalizeUkoiCartDrawer();
  normalizeUkoiMainCart();
}

function updateUkoiCartShipping(drawer) {
  drawer.querySelectorAll('.ukoi-cart-free-shipping').forEach((node) => node.remove());

  const shippingBlocks = drawer.querySelectorAll('.cart-shipping');
  const footer = drawer.querySelector('.cart-drawer__footer');
  const taxNote = footer ? footer.querySelector('.tax-note') : null;

  if (!taxNote) return;

  if (!shippingBlocks.length) {
    taxNote.classList.add('ukoi-cart-shipping-status');
    return;
  }

  let messageText = '';

  shippingBlocks.forEach((block) => {
    const total = Number(block.dataset.total || 0);
    const minSpend = Number(block.dataset.minSpend || 0);
    const rate = window.Shopify && Shopify.currency ? Number(Shopify.currency.rate || 1) : 1;
    const minTotal = Math.round(minSpend * rate);
    const defaultMessage = block.dataset.message || '||amount|| away from free shipping!';

    if (minTotal && total < minTotal) {
      const amount = minTotal - total;
      const formattedAmount = typeof formatMoney === 'function' ? formatMoney(amount) : `$${Math.ceil(amount / 100)}`;
      messageText = defaultMessage.replace('||amount||', formattedAmount);
    } else {
      messageText = 'FREE US SHIPPING APPLIED!';
    }

    block.remove();
  });

  if (messageText) {
    taxNote.classList.add('ukoi-cart-shipping-status');
    taxNote.textContent = messageText;
  }
}

function updateUkoiCartProductSublines(drawer) {
  drawer.querySelectorAll('.cart-item__name').forEach((titleLink) => {
    if (!isUkoiSnailCartTitle(titleLink)) return;

    let stack = titleLink.closest('.ukoi-cart-title-stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'ukoi-cart-title-stack';
      titleLink.parentNode.insertBefore(stack, titleLink);
      stack.appendChild(titleLink);
    }

    if (!stack.querySelector('.ukoi-cart-product-subline')) {
      const subline = document.createElement('div');
      subline.className = 'ukoi-cart-product-subline';
      subline.textContent = 'LIMITED DROP · $151 VALUE → now $51';
      stack.appendChild(subline);
    }
  });
}

function updateUkoiExosomePromoPresentation(root) {
  root.querySelectorAll('.cart-item').forEach((cartItem) => {
    if (!isUkoiExosomeCartItem(cartItem)) return;

    removeUkoiPromoDiscountRows(cartItem);
    renderUkoiPromoPrice(cartItem, {
      current: getUkoiMoney(UKOI_PROMO_PRESENTATION.prices && UKOI_PROMO_PRESENTATION.prices.exosomePrice),
      compareAt: getUkoiMoney(UKOI_PROMO_PRESENTATION.prices && UKOI_PROMO_PRESENTATION.prices.exosomeCompareAt)
    });
  });

  ensureUkoiPromoPrices().then(() => {
    root.querySelectorAll('.cart-item').forEach((cartItem) => {
      if (!isUkoiExosomeCartItem(cartItem)) return;

      renderUkoiPromoPrice(cartItem, {
        current: getUkoiMoney(UKOI_PROMO_PRESENTATION.prices.exosomePrice),
        compareAt: getUkoiMoney(UKOI_PROMO_PRESENTATION.prices.exosomeCompareAt)
      });
    });
  });
}

function updateUkoiSpfGiftPresentation(root) {
  root.querySelectorAll('.cart-item').forEach((cartItem) => {
    if (!isUkoiSpfGiftCartItem(cartItem)) return;

    removeUkoiPromoDiscountRows(cartItem);
    renderUkoiGiftPrice(cartItem);
  });
}

function renderUkoiPromoPrice(cartItem, prices) {
  const priceWrapper = cartItem.querySelector('.cart-item__price-wrapper');
  if (!priceWrapper || !prices.current || !prices.compareAt) return;

  priceWrapper.classList.add('ukoi-promo-price-wrapper');
  priceWrapper.innerHTML = `
    <span class="cart-item__final-price">${prices.current}</span>
    <s class="cart-item__old-price">${prices.compareAt}</s>
  `;
}

function renderUkoiGiftPrice(cartItem) {
  const priceWrapper = cartItem.querySelector('.cart-item__price-wrapper');
  if (!priceWrapper) return;

  priceWrapper.classList.add('ukoi-promo-price-wrapper', 'ukoi-promo-price-wrapper--gift');
  priceWrapper.innerHTML = '<span class="cart-item__final-price ukoi-cart-gift-price">FREE</span>';
}

function removeUkoiPromoDiscountRows(cartItem) {
  cartItem.querySelectorAll('.discounts__discount').forEach((discountRow) => {
    const discountText = discountRow.textContent.replace(/\s+/g, ' ').trim().toUpperCase();

    if (!discountText.includes(UKOI_PROMO_PRESENTATION.discountTitle.toUpperCase())) return;

    const discountsList = discountRow.closest('.discounts');
    discountRow.remove();

    if (discountsList && !discountsList.querySelector('.discounts__discount')) {
      discountsList.remove();
    }
  });
}

function ensureUkoiPromoPrices() {
  if (UKOI_PROMO_PRESENTATION.prices) return Promise.resolve(UKOI_PROMO_PRESENTATION.prices);
  if (UKOI_PROMO_PRESENTATION.pricesPromise) return UKOI_PROMO_PRESENTATION.pricesPromise;

  UKOI_PROMO_PRESENTATION.pricesPromise = fetch(`/products/${UKOI_PROMO_PRESENTATION.exosomeHandle}.js`)
    .then((response) => response.ok ? response.json() : null)
    .then((product) => {
      const variant = product && product.variants
        ? product.variants.find((item) => String(item.id) === UKOI_PROMO_PRESENTATION.exosomeVariantId) || product.variants[0]
        : null;

      UKOI_PROMO_PRESENTATION.prices = {
        exosomePrice: variant ? variant.price : null,
        exosomeCompareAt: variant ? variant.compare_at_price : null
      };

      return UKOI_PROMO_PRESENTATION.prices;
    })
    .catch(() => {
      UKOI_PROMO_PRESENTATION.prices = {};
      return UKOI_PROMO_PRESENTATION.prices;
    });

  return UKOI_PROMO_PRESENTATION.pricesPromise;
}

function getUkoiMoney(cents) {
  if (!cents) return '';
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents);
  }
  if (typeof formatMoney === 'function') {
    return formatMoney(cents);
  }
  return `$${(Number(cents) / 100).toFixed(2)}`;
}

function removeUkoiSnailBuyXGetYDiscountRows(drawer) {
  drawer.querySelectorAll('.cart-item').forEach((cartItem) => {
    const titleLink = cartItem.querySelector('.cart-item__name');
    if (!titleLink || !isUkoiSnailCartTitle(titleLink)) return;

    cartItem.querySelectorAll('.discounts__discount').forEach((discountRow) => {
      const discountText = discountRow.textContent.replace(/\s+/g, ' ').trim().toUpperCase();
      const isBuyXGetYLabel = discountText.includes('SNAIL MUCIN + SET') && discountText.includes('50% OFF');

      if (!isBuyXGetYLabel) return;

      const discountsList = discountRow.closest('.discounts');
      discountRow.remove();

      if (discountsList && !discountsList.querySelector('.discounts__discount')) {
        discountsList.remove();
      }
    });
  });
}

function updateUkoiEmptyCartCta(drawer) {
  const emptyCartButton = drawer.querySelector('.cart__empty-button');
  if (!emptyCartButton) return;

  emptyCartButton.setAttribute('href', '/collections/sets');
  emptyCartButton.setAttribute('data-button-text', 'GO TO SETS');
  emptyCartButton.setAttribute('aria-label', 'GO TO SETS');

  const buttonText = emptyCartButton.querySelector('span');
  if (buttonText) {
    buttonText.textContent = 'GO TO SETS';
  }
}

function isUkoiSnailCartTitle(titleLink) {
  const href = titleLink.getAttribute('href') || '';
  const title = titleLink.textContent.trim();
  const handleMatch = /\/products\/[^/?#]*snail[^/?#]*mucin/i.test(href);
  const titleMatch = title === 'Snail Mucin Hydration & Glow System';

  return handleMatch || titleMatch;
}

function isUkoiExosomeCartItem(cartItem) {
  const titleLink = cartItem.querySelector('.cart-item__name');
  const href = titleLink ? titleLink.getAttribute('href') || '' : '';
  const title = titleLink ? titleLink.textContent.trim() : '';
  const variantId = cartItem.dataset.variantId || '';

  return variantId === UKOI_PROMO_PRESENTATION.exosomeVariantId ||
    href.includes(`/products/${UKOI_PROMO_PRESENTATION.exosomeHandle}`) ||
    title === UKOI_PROMO_PRESENTATION.exosomeTitle;
}

function isUkoiSpfGiftCartItem(cartItem) {
  return Boolean(cartItem.querySelector('.ukoi-cart-gift-label'));
}

(function () {
  const style = document.createElement('style');
  style.textContent = `
    #CartDrawer .ukoi-cart-title-stack {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      min-width: 0;
    }

    #CartDrawer .ukoi-cart-product-subline {
      margin-top: 0.4rem;
      color: rgb(var(--color-foreground-secondary));
      font-family: var(--font-body-family);
      font-size: 1.2rem;
      font-weight: 400;
      line-height: var(--font-body-line-height);
      letter-spacing: -0.01em;
      text-transform: none;
      overflow-wrap: anywhere;
    }

    #CartDrawer .ukoi-cart-shipping-status {
      display: block;
      width: 100%;
      margin: 0;
      color: rgb(var(--color-foreground));
      font-family: var(--font-body-family);
      font-size: 1.4rem;
      font-weight: 700;
      line-height: var(--font-body-line-height);
      letter-spacing: -0.01em;
      text-align: right;
    }

    #CartDrawer .ukoi-promo-price-wrapper,
    .main-cart .ukoi-promo-price-wrapper {
      display: flex;
      align-items: baseline;
      flex-wrap: wrap;
      gap: 0.6rem;
    }

    #CartDrawer .ukoi-promo-price-wrapper .cart-item__old-price,
    .main-cart .ukoi-promo-price-wrapper .cart-item__old-price {
      color: rgba(var(--color-foreground), 0.6);
      text-decoration: line-through;
      text-decoration-color: rgba(var(--color-foreground), 0.6);
    }

    #CartDrawer .ukoi-cart-gift-price,
    .main-cart .ukoi-cart-gift-price {
      font-weight: var(--font-button-weight);
    }
  `;
  document.head.appendChild(style);

  document.addEventListener('DOMContentLoaded', normalizeUkoiCartPresentation);
  document.addEventListener('cart:change', () => setTimeout(normalizeUkoiCartPresentation));
  document.addEventListener('line-item:change', () => setTimeout(normalizeUkoiCartPresentation));
  document.addEventListener('cart:error', () => setTimeout(normalizeUkoiCartPresentation));
})();

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
